module.exports = __webpack_public_path__ + "img/pics_long-term-relationship.6614d0bd.svg";